const Header = () => {
  return <h1>Genre Gaming Opinion Hub</h1>;
};

export default Header;
